import type { GTMEcommerceReturnType, GTMItemData, GTMItemsReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';
import { calculateValue, useFallbackForEmptyCategories } from '../GTMHelpers';

interface GTMAddToCartEcommerceReturnType {
    items: GTMItemsReturnType[];
    value: number;
}

export default class GTMDetailAddToCartButtonClickModel extends GTMBaseModel {
    public static parseToGTMData({
        id,
        title,
        country,
        region,
        department,
        place,
        discount,
        pricePerNight,
        instantBooking,
        quantity
    }: GTMItemData): GTMEcommerceReturnType<GTMAddToCartEcommerceReturnType> {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'web_event',
            ga4_event_name: 'add_to_cart',
            ecommerce: {
                value: calculateValue(pricePerNight, quantity),
                items: [
                    {
                        index: 0,
                        item_id: id,
                        item_name: title,
                        ...useFallbackForEmptyCategories({
                            country,
                            region,
                            department,
                            place
                        }),
                        discount,
                        quantity,
                        price: pricePerNight,
                        instant_booking: instantBooking
                    }
                ]
            }
        };
    }
}
